
// Limpieza defensiva: Shopify a veces inyecta un ">" suelto como primer nodo de <body>
// (antes de nuestro contenido) al reubicar scripts internos (checkout preloads, digital wallet, etc.)
// Esto no viene de nuestro Liquid: el HTML servido es correcto, pero el runtime de Shopify
// lo modifica en el cliente. Lo quitamos apenas corre este script.
(function(){
  var fc = document.body.firstChild;
  if(fc && fc.nodeType === 3 && fc.textContent.trim() === '>'){ fc.remove(); }
})();
/* Canominoxidil — carrito conectado a la API nativa de Shopify (AJAX Cart) */
(function(){

  function formatoCOP(centavos){
    var valor = Math.round(centavos/100);
    return '$' + valor.toLocaleString('es-CO');
  }

  function $(sel, ctx){ return (ctx||document).querySelector(sel); }
  function $all(sel, ctx){ return Array.prototype.slice.call((ctx||document).querySelectorAll(sel)); }

  // ── Drawer del carrito ──
  window.toggleDrawer = function(){
    var overlay = $('#overlay'), drawer = $('#drawer');
    if(!overlay || !drawer) return;
    var abriendo = !drawer.classList.contains('open');
    overlay.classList.toggle('open');
    drawer.classList.toggle('open');
    if(abriendo) refrescarCarrito();
  };

  function refrescarCarrito(){
    fetch('/cart.js').then(function(r){ return r.json(); }).then(pintarCarrito);
  }

  function pintarCarrito(cart){
    var cont = $('#drawerItems');
    var totalEl = $('#cartTotal');
    var countEl = $('#cartCount');
    if(!cont) return;
    if(countEl) countEl.textContent = cart.item_count;
    if(totalEl) totalEl.textContent = formatoCOP(cart.total_price);
    if(cart.item_count === 0){
      cont.innerHTML = '<p class="drawer-empty"><svg viewBox="0 0 24 24" fill="none" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" xmlns="http://www.w3.org/2000/svg"><path d="M6 6h15l-1.5 9h-12z"/><path d="M6 6L5 3H2"/><circle cx="9" cy="20" r="1"/><circle cx="18" cy="20" r="1"/></svg><br>Aún no has agregado productos.</p>';
      return;
    }
    var html = '';
    cart.items.forEach(function(item){
      html += '<div class="drawer-item" data-key="'+item.key+'">'
        + '<div class="di-thumb"><img src="'+(item.image||'')+'" alt="" loading="lazy"></div>'
        + '<div class="di-info"><b>'+item.product_title+'</b>'
        + '<div class="di-stepper">'
        + '<button type="button" onclick="ajustarCantidad(\''+item.key+'\','+(item.quantity-1)+')">−</button>'
        + '<span>'+item.quantity+'</span>'
        + '<button type="button" onclick="ajustarCantidad(\''+item.key+'\','+(item.quantity+1)+')">+</button>'
        + '</div></div>'
        + '<div class="di-right"><span class="precio">'+formatoCOP(item.final_line_price)+'</span>'
        + '<button type="button" class="di-remove" onclick="ajustarCantidad(\''+item.key+'\',0)" aria-label="Quitar">×</button></div>'
        + '</div>';
    });
    cont.innerHTML = html;

    // Página de carrito completa (si existe en esta vista)
    var paginaCont = $('#carritoPaginaItems');
    var paginaTotal = $('#carritoPaginaTotal');
    if(paginaCont){
      if(cart.item_count === 0){ window.location.reload(); return; }
      paginaCont.innerHTML = html;
      if(paginaTotal) paginaTotal.textContent = formatoCOP(cart.total_price);
    }
  }

  window.ajustarCantidad = function(key, qty){
    fetch('/cart/change.js', {
      method:'POST',
      headers:{'Content-Type':'application/json'},
      body: JSON.stringify({id:key, quantity: Math.max(0,qty)})
    }).then(function(r){ return r.json(); }).then(pintarCarrito);
  };

  // ── Animación única "Agregar al carrito": un ícono de carrito vuela desde el botón hasta el ícono del header ──
  function lanzarAnimacionCarrito(btn){
    var cartLink = $('.cart-link');
    if(!cartLink || !btn) return;
    var startRect = btn.getBoundingClientRect();
    var endRect = cartLink.getBoundingClientRect();
    var startX = startRect.left + startRect.width/2 - 11;
    var startY = startRect.top + startRect.height/2 - 11;
    var endX = endRect.left + endRect.width/2 - 11;
    var endY = endRect.top + endRect.height/2 - 11;
    var fly = document.createElement('div');
    fly.className = 'cart-fly';
    fly.style.setProperty('--sx', startX + 'px');
    fly.style.setProperty('--sy', startY + 'px');
    fly.style.setProperty('--dx', (endX - startX) + 'px');
    fly.style.setProperty('--dy', (endY - startY) + 'px');
    fly.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" xmlns="http://www.w3.org/2000/svg"><path d="M5 8h14l-1.2 12a2 2 0 0 1-2 1.8H8.2a2 2 0 0 1-2-1.8L5 8z"/><path d="M8.5 8V6.5a3.5 3.5 0 0 1 7 0V8"/></svg>';
    document.body.appendChild(fly);
    fly.addEventListener('animationend', function(){
      fly.remove();
      cartLink.classList.remove('cart-bounce');
      void cartLink.offsetWidth;
      cartLink.classList.add('cart-bounce');
    });
  }

  window.addToCart = function(variantId, btn, cantidad){
    if(!variantId) return;
    var boton = btn && btn.nodeType ? btn : null;
    if(boton){ boton.disabled = true; }
    fetch('/cart/add.js', {
      method:'POST',
      headers:{'Content-Type':'application/json'},
      body: JSON.stringify({items:[{id: variantId, quantity: cantidad||1}]})
    }).then(function(r){ return r.json(); }).then(function(){
      refrescarCarrito();
      if(boton){
        lanzarAnimacionCarrito(boton);
        var textoOriginal = boton.innerHTML;
        boton.classList.add('btn-added');
        boton.innerHTML = '<svg class="check-pop" viewBox="0 0 24 24" fill="none" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" xmlns="http://www.w3.org/2000/svg"><path d="M20 6 9 17l-5-5"/></svg> Agregado';
        setTimeout(function(){ boton.innerHTML = textoOriginal; boton.classList.remove('btn-added'); boton.disabled = false; }, 1200);
      }
      var overlay = $('#overlay'), drawer = $('#drawer');
      if(overlay && drawer && !drawer.classList.contains('open')){
        setTimeout(function(){
          overlay.classList.add('open'); drawer.classList.add('open');
        }, boton ? 480 : 0);
      }
    }).catch(function(){ if(boton) boton.disabled = false; });
  };
    window.buyNow = function(variantId, btn){
          if(!variantId) return;
              var boton = btn && btn.nodeType ? btn : null;
                  if(boton){ boton.disabled = true; }
                      fetch('/cart/add.js', {
                            method:'POST',
                                  headers:{'Content-Type':'application/json'},
                                        body: JSON.stringify({items:[{id: variantId, quantity: 1}]})
                                            }).then(function(){
                                                  var link = document.querySelector('a[href="/checkout"]');
                                                        if(link){ link.click(); }
                                                              else { window.location.href = '/checkout'; }
                                                                  }).catch(function(){
                                                                        window.location.href = '/checkout';
                                                                            });
                                                                              };
    
  document.addEventListener('DOMContentLoaded', function(){
    refrescarCarrito();

    // Menú hamburguesa
    var burger = $('.hamburger');
    if(burger){
      burger.addEventListener('click', function(){
        $('#navLinks').classList.toggle('open');
        burger.classList.toggle('open');
      });
    }

    // FAQ / acordeón: son <details> nativos, no requieren JS.

    // Reveal on scroll
    var reveals = $all('.reveal');
    if(reveals.length && 'IntersectionObserver' in window){
      var io = new IntersectionObserver(function(entries){
        entries.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('visible'); io.unobserve(e.target); } });
      }, {threshold:.12});
      reveals.forEach(function(el){ io.observe(el); });
    } else {
      reveals.forEach(function(el){ el.classList.add('visible'); });
    }

    // Carrusel de productos / testimonios (flechas)
    window.deslizarCarrusel = function(id, dir){
      var track = document.getElementById(id);
      if(!track) return;
      var item = track.querySelector(':scope > *');
      var paso = item ? item.getBoundingClientRect().width + 26 : 300;
      track.scrollBy({left: dir*paso*2, behavior:'smooth'});
      var pausarFn = window['_pausarCarrusel_'+id]; if(pausarFn) pausarFn();
    };

    // Galería de producto: miniaturas
    window.cambiarFoto = function(src, thumbBtn){
      var principal = $('#fotoPrincipal');
      if(principal) principal.src = src;
      $all('.prod-thumb').forEach(function(t){ t.classList.remove('activo'); });
      if(thumbBtn) thumbBtn.classList.add('activo');
    };

      // Carrusel de reseñas "pro": ir a una tarjeta por índice (dots) + tarjeta/dot activos
      window.irAReview = function(idx){
        var track = document.getElementById('reviewsTrack');
        if(!track) return;
        var card = track.children[idx];
        if(card) track.scrollTo({left: card.offsetLeft - track.offsetLeft, behavior:'smooth'});
      };
      (function(){
        var track = document.getElementById('reviewsTrack');
        var dotsWrap = document.getElementById('reviewsDots');
        if(!track || !dotsWrap) return;
        var cards = $all('.review-pro-card', track);
        var dots = $all('button', dotsWrap);
        if('IntersectionObserver' in window){
          var io4 = new IntersectionObserver(function(entries){
            entries.forEach(function(e){
              var idx = cards.indexOf(e.target);
              if(idx === -1) return;
              var activa = e.isIntersecting && e.intersectionRatio > 0.6;
              e.target.classList.toggle('rp-activa', activa);
              if(activa){ dots.forEach(function(d,i){ d.classList.toggle('activo', i===idx); }); }
            });
          }, {root: track, threshold:[0,.6,1]});
          cards.forEach(function(c){ io4.observe(c); });
        }
      })();


          // Barra sticky de compra en producto (aparece al hacer scroll, se oculta sobre el footer)
      var sticky = $('#stickyBuyProd');
      var accionesProd = $('.prod-acciones');
      var footerEl = document.querySelector('footer');
      if(sticky && accionesProd && 'IntersectionObserver' in window){
        var pasadoBoton = false;
        var footerVisible = false;
        var actualizarSticky = function(){
          sticky.classList.toggle('visible', pasadoBoton && !footerVisible);
        };
        var io2 = new IntersectionObserver(function(entries){
          entries.forEach(function(e){ pasadoBoton = !e.isIntersecting; });
          actualizarSticky();
        }, {threshold:0});
        io2.observe(accionesProd);
        if(footerEl){
          var io3 = new IntersectionObserver(function(entries){
            entries.forEach(function(e){ footerVisible = e.isIntersecting; });
            actualizarSticky();
          }, {threshold:0});
          io3.observe(footerEl);
        }
      }

    // Auto-desplazamiento lento del carrusel de productos — se detiene al interactuar
    function iniciarAutoScrollCarrusel(gridId, velocidad){
        var grid = document.getElementById(gridId);
      if(!grid) return;
        var direccion = 1, pausado = false, reanudarTimeout = null;
      var posicion = grid.scrollLeft, ultimoTS = null;
      grid.style.scrollSnapType = 'none';
      function paso(ts){
        var maxScroll = grid.scrollWidth - grid.clientWidth;
        if(!pausado && maxScroll > 1){
          var delta = ultimoTS ? (ts - ultimoTS) : 16.7;
          delta = Math.min(delta, 50);
          posicion += velocidad * direccion * (delta / 16.7);
          if(posicion >= maxScroll){ posicion = maxScroll; direccion = -1; }
          else if(posicion <= 0){ posicion = 0; direccion = 1; }
          grid.scrollLeft = Math.round(posicion);
        } else { posicion = grid.scrollLeft; }
        ultimoTS = ts;
        requestAnimationFrame(paso);
      }
      requestAnimationFrame(paso);
      function pausar(){ pausado = true; clearTimeout(reanudarTimeout); }
      function reanudarLuego(ms){ clearTimeout(reanudarTimeout); reanudarTimeout = setTimeout(function(){ posicion = grid.scrollLeft; pausado = false; }, ms || 2600); }
      grid.addEventListener('mouseenter', pausar);
      grid.addEventListener('mouseleave', function(){ reanudarLuego(600); });
      grid.addEventListener('touchstart', pausar, {passive:true});
      grid.addEventListener('touchend', function(){ reanudarLuego(2600); }, {passive:true});
      grid.addEventListener('wheel', function(){ pausar(); reanudarLuego(2600); }, {passive:true});
          window['_pausarCarrusel_'+gridId] = function(){ pausar(); reanudarLuego(2600); };
    }

  window.scrollCarrusel = function(gridId, dir){
    var grid = document.getElementById(gridId);
    if(!grid) return;
    var card = grid.querySelector('.prod-card');
    var amount = card ? (card.getBoundingClientRect().width + 26) : 280;
    grid.scrollBy({ left: dir * amount * 2, behavior: 'smooth' });
    var pausarFn = window['_pausarCarrusel_' + gridId];
    if(pausarFn) pausarFn();
  };

    iniciarAutoScrollCarrusel('prodGridTienda', 0.6);
    iniciarAutoScrollCarrusel('testiGrid', 0.35);

    // Rotador de mensajes del anuncio superior (solo home, ya viene con inline script si aplica)

    // Rotación de asesor de WhatsApp entre los dos números
    var wspLinks = $all('.wsp-link, #wspBtn');
    if(wspLinks.length){
      var numeros = ['573195202201','573503462346'];
      var elegido = numeros[Math.floor(Math.random()*numeros.length)];
      var msg = encodeURIComponent('Hola, tengo una pregunta sobre los productos de Canominoxidil.');
      wspLinks.forEach(function(a){ a.href = 'https://wa.me/'+elegido+'?text='+msg; });
    }
  });
  // Filtro de categorías del catálogo (Todos, Tratamiento, Cuidado diario, etc.)
  window.filtrarProductos = function(btn){
    $all('.filtro').forEach(function(f){ f.classList.remove('activo'); });
    btn.classList.add('activo');
    var cat = btn.dataset.cat;
    $all('#prodGridTienda .prod-card').forEach(function(card){
      if(cat === 'todos' || card.dataset.categoria === cat){
        card.classList.remove('oculto');
      } else {
        card.classList.add('oculto');
      }
    });
  };

})();


// Reseñas "pro": arrastrar con mouse para deslizar el carrusel (drag-to-scroll)
(function(){
  var track = document.getElementById('reviewsTrack');
  if(!track) return;
  var isDown = false, startX = 0, scrollStart = 0, moved = false;
  track.addEventListener('mousedown', function(e){
    isDown = true; moved = false;
    startX = e.pageX; scrollStart = track.scrollLeft;
    track.classList.add('rp-dragging');
  });
  window.addEventListener('mouseup', function(){
    if(!isDown) return;
    isDown = false;
    track.classList.remove('rp-dragging');
  });
  window.addEventListener('mousemove', function(e){
    if(!isDown) return;
    var dx = e.pageX - startX;
    if(Math.abs(dx) > 4) moved = true;
    track.scrollLeft = scrollStart - dx;
  });
  track.addEventListener('click', function(e){
    if(moved){ e.stopPropagation(); e.preventDefault(); moved = false; }
  }, true);
})();


// ===== Animaciones "pro" sitewide: reveal extendido, titulos palabra por palabra, ripple en botones =====
(function(){
  if(window.__proAnimInit) return; window.__proAnimInit = true;

  var extra = document.querySelectorAll('.sec-head, .mecanismo-grid, .anuncio-bar, .review-pro-carrusel, .blog-grid, .blog-card, .ciencia-grid, .faq, .prod-detail-grid, .carrito-grid, .prod-card, .guia-card');
  extra.forEach(function(el){ if(!el.classList.contains('reveal')) el.classList.add('reveal'); });

  if('IntersectionObserver' in window){
    var io2 = new IntersectionObserver(function(entries){
      entries.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('visible'); io2.unobserve(e.target); } });
    }, {threshold:.12, rootMargin:'0px 0px -40px 0px'});
    extra.forEach(function(el){ io2.observe(el); });
  } else {
    extra.forEach(function(el){ el.classList.add('visible'); });
  }

  function splitTitle(el){
    if(!el || el.dataset.split) return;
    el.dataset.split = '1';
    var frag = document.createDocumentFragment();
    el.childNodes.forEach(function(node){
      if(node.nodeType === 3){
        var parts = node.textContent.split(/(\s+)/);
        parts.forEach(function(p){
          if(p.trim() === ''){ frag.appendChild(document.createTextNode(p)); }
          else { var span = document.createElement('span'); span.className = 'split-word'; span.textContent = p; frag.appendChild(span); }
        });
      } else {
        var span = document.createElement('span'); span.className = 'split-word'; span.appendChild(node.cloneNode(true)); frag.appendChild(span);
      }
    });
    el.innerHTML = ''; el.appendChild(frag); el.classList.add('split-title');
    var i = 0; el.querySelectorAll('.split-word').forEach(function(w){ w.style.setProperty('--i', i++); });
  }

  var titles = document.querySelectorAll('.hero h1, .sec-head h2');
  titles.forEach(splitTitle);

  if('IntersectionObserver' in window){
    var io3 = new IntersectionObserver(function(entries){
      entries.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('in-view'); io3.unobserve(e.target); } });
    }, {threshold:.2});
    titles.forEach(function(t){ io3.observe(t); });
  } else {
    titles.forEach(function(t){ t.classList.add('in-view'); });
  }

  document.addEventListener('click', function(e){
    var btn = e.target.closest('.btn, .btn-inv, .btn-line, .btn-line-inv, .add-btn');
    if(!btn) return;
    var rect = btn.getBoundingClientRect();
    var size = Math.max(rect.width, rect.height);
    var ripple = document.createElement('span');
    ripple.className = 'btn-ripple';
    ripple.style.width = ripple.style.height = size + 'px';
    ripple.style.left = (e.clientX - rect.left - size/2) + 'px';
    ripple.style.top = (e.clientY - rect.top - size/2) + 'px';
    btn.appendChild(ripple);
    setTimeout(function(){ ripple.remove(); }, 650);
  });
})();